export function isMobileViewHook(setIsMobile, width) {
  window.addEventListener("load", () => {
    getWidthAndDecideScreen(setIsMobile, width);
  });
  window.addEventListener("resize", () => {
    getWidthAndDecideScreen(setIsMobile, width);
  });
  getWidthAndDecideScreen(setIsMobile, width);
}

function getWidthAndDecideScreen(setIsMobile, width) {
  const requiredWidth = width ? width : 769;
  if (window.screen.width < requiredWidth) {
    setIsMobile(true);
  } else {
    setIsMobile(false);
  }
}
